import React, { createContext, useContext, ReactNode } from 'react';

interface AppContextType {
  $store: any;
  $commitToStore: (data: any) => void;
}

const AppContext = createContext<AppContextType | null>(null);

interface AppProviderProps {
  children: ReactNode;
  $store: any;
  $commitToStore: (data: any) => void;
}

export function AppProvider({ children, $store, $commitToStore }: AppProviderProps) {
  return (
    <AppContext.Provider value={{ $store, $commitToStore }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext(): AppContextType {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}

// Глобальная функция для получения контекста из любого места
let globalAppContext: AppContextType | null = null;

export function setGlobalAppContext(context: AppContextType) {
  globalAppContext = context;
}

export function getGlobalAppContext(): AppContextType | null {
  return globalAppContext;
}
